/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Voice_Agents_Inbound_Title7Inputs */

const en_svc_ai_voice_agents_inbound_title7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Inbound_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inbound answering`)
};

const ar_svc_ai_voice_agents_inbound_title7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Inbound_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الرد على المكالمات الواردة`)
};

const bn_svc_ai_voice_agents_inbound_title7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Inbound_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ইনবাউন্ড কল ধরা`)
};

const de_svc_ai_voice_agents_inbound_title7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Inbound_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anrufannahme`)
};

const es_svc_ai_voice_agents_inbound_title7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Inbound_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atención de llamadas entrantes`)
};

const fr_svc_ai_voice_agents_inbound_title7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Inbound_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réponse aux appels entrants`)
};

const pt_svc_ai_voice_agents_inbound_title7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Inbound_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atendimento de chamadas recebidas`)
};

const zh_svc_ai_voice_agents_inbound_title7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Inbound_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`呼入接听`)
};

const tr_svc_ai_voice_agents_inbound_title7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Inbound_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gelen çağrı karşılama`)
};

const ru_svc_ai_voice_agents_inbound_title7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Inbound_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Приём входящих звонков`)
};

const pl_svc_ai_voice_agents_inbound_title7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Inbound_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odbieranie połączeń`)
};

/**
* | output |
* | --- |
* | "Inbound answering" |
*
* @param {Svc_Ai_Voice_Agents_Inbound_Title7Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_voice_agents_inbound_title7 = /** @type {((inputs?: Svc_Ai_Voice_Agents_Inbound_Title7Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Voice_Agents_Inbound_Title7Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_voice_agents_inbound_title7(inputs)
	if (locale === "bn") return bn_svc_ai_voice_agents_inbound_title7(inputs)
	if (locale === "de") return de_svc_ai_voice_agents_inbound_title7(inputs)
	if (locale === "es") return es_svc_ai_voice_agents_inbound_title7(inputs)
	if (locale === "fr") return fr_svc_ai_voice_agents_inbound_title7(inputs)
	if (locale === "pt") return pt_svc_ai_voice_agents_inbound_title7(inputs)
	if (locale === "zh") return zh_svc_ai_voice_agents_inbound_title7(inputs)
	if (locale === "tr") return tr_svc_ai_voice_agents_inbound_title7(inputs)
	if (locale === "ru") return ru_svc_ai_voice_agents_inbound_title7(inputs)
	if (locale === "pl") return pl_svc_ai_voice_agents_inbound_title7(inputs)
	return en_svc_ai_voice_agents_inbound_title7(inputs)
});
export { svc_ai_voice_agents_inbound_title7 as "svc_ai-voice-agents_INBOUND_title" }